export default {
  namespaced: true,
  state: {
    snackbar: {
      visible: false,
      content: '',
      color: 'info',
    },
  },
  mutations: {
    setSnackbar(state, { content, color }) {
      state.snackbar = { visible: true, content, color };
    },
    closeSnackbar(state) {
      state.snackbar.visible = false;
    },
  },
  actions: {
    triggerSnackbar({ commit }, { content, color = 'info' }) {
      commit('setSnackbar', { content, color });

      setTimeout(() => {
        commit('closeSnackbar');
      }, 3000);
    },

    closeSnackbar({ commit }) {
      commit('closeSnackbar');
    },
  },
  getters: {
    snackbar: (state) => state.snackbar,
  },
};
